import { render } from "./AdminAddnotification.vue?vue&type=template&id=3f0f50ce&scoped=true"
import script from "./AdminAddnotification.vue?vue&type=script&lang=js"
export * from "./AdminAddnotification.vue?vue&type=script&lang=js"

import "./AdminAddnotification.vue?vue&type=style&index=0&id=3f0f50ce&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0f50ce"]])

export default __exports__